import { render, staticRenderFns } from "./PurchasingWaybillReport.vue?vue&type=template&id=bfda60ea&"
import script from "./PurchasingWaybillReport.vue?vue&type=script&lang=js&"
export * from "./PurchasingWaybillReport.vue?vue&type=script&lang=js&"
import style0 from "./PurchasingWaybillReport.vue?vue&type=style&index=0&id=bfda60ea&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports